// Project (Non-Penyedia, /project-pbj, feature projects; reference
// projects): every PBJ project of the user as a card, reached from "Lihat
// semua" in the sidebar Project section and on the Dashboard PBJ.
//   header    plain spacing   h1, one sentence, Paket PBJ baru
//   projects  cards           one card per PBJ project (pbj/ProjectCard):
//                             stage and TA, name, unit kerja and jenis,
//                             jalur with metode or tipe, progress % with
//                             done/total, Kelola; then a dashed Paket PBJ
//                             baru card. None yet: one empty state.
// Folder projects stay in the sidebar only. The list reloads when the shared
// project list changes (a project made, renamed or removed).
import * as API from "../api";
import { useUser } from "../auth";
import { formatCount } from "../lib/format";
import { ROLE_LABEL } from "../lib/labels";
import { PbjProjectCard } from "../pbj/ProjectCard";
import { useProjects } from "../shell/Projects";
import { EmptyState, Notice, PageHeader, SkeletonRows, useAsync, useTitle } from "../ui/components";
import { Glyph } from "../ui/icons";

export function ProjectsPbjScreen() {
  useTitle("Project PBJ");
  const user = useUser();
  const projects = useProjects();
  const list = useAsync(() => API.listPbjProjects(), [projects?.list.data, user.role]);
  const create = projects ? (
    <button type="button" className="btn btn-primary" onClick={projects.openCreate}>
      <Glyph name="add" size={18} />
      <span>Paket PBJ baru</span>
    </button>
  ) : undefined;
  const items = list.data ?? [];

  return (
    <>
      <PageHeader
        divided
        title="Project PBJ"
        lead={`Buat paket dan ikuti tahap PBJ sesuai kewenangan peran. Anda bekerja dalam mode ${ROLE_LABEL[user.role]}.`}
        actions={create}
      />
      {list.loading && !list.data ? (
        <SkeletonRows count={3} label="Memuat project" />
      ) : list.error ? (
        <Notice tone="danger" title="Project belum termuat" action={<button type="button" className="btn btn-secondary" onClick={list.reload}>Muat ulang</button>}>
          <p>{API.errorMessage(list.error)}</p>
        </Notice>
      ) : items.length === 0 ? (
        <EmptyState icon="building" title="Belum ada paket PBJ" body="Buat paket PBJ untuk mengikuti tahap pengadaan, dari rencana kerja dan anggaran sampai serah terima." action={create} />
      ) : (
        <section className="region" aria-label="Daftar paket PBJ">
          <p className="pbj-next">{formatCount(items.length)} paket PBJ</p>
          <ul className="pbj-cards" aria-label="Paket PBJ">
            {items.map((p) => (
              <li key={p.id}>
                <PbjProjectCard project={p} />
              </li>
            ))}
            {projects ? (
              <li>
                <button type="button" className="pbj-card pbj-card-new" aria-haspopup="dialog" onClick={projects.openCreate}>
                  <Glyph name="add" size={24} />
                  <span className="pbj-card-title">Paket PBJ baru</span>
                  <span className="pbj-card-meta">Mulai dari tahap Perencanaan</span>
                </button>
              </li>
            ) : null}
          </ul>
        </section>
      )}
    </>
  );
}
